import React, { useEffect, useState, useRef } from 'react';
import { Link, Outlet } from 'react-router-dom';
import Table from '../../Components/Script/Table';
import { getAllCreditCard, updateCreditCardStatus } from '../../Services/creditCard';
import $ from 'jquery';


function AllCreditCardDataAdmin() {
    const [creditCards, setCreditCards] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [status, setStatus] = useState("Pending");
    const [loading, setLoading] = useState(true);
    const [screenshot, setScreenshot] = useState(null);
    const [csId, setCsId] = useState("");
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.id;
    const tableRef = useRef(null);


    useEffect(() => {
        fetchCreditCards();
    }, []);

    useEffect(() => {
        if (
            loading ||
            !creditCards.length ||
            !tableRef.current ||
            !window.$ ||
            !$.fn ||
            !$.fn.DataTable
        ) {
            return;
        }

        const table = $(tableRef.current);

        if ($.fn.DataTable.isDataTable(table)) {
            table.DataTable().destroy();
        }

        setTimeout(() => {
            table.DataTable({
                scrollX: true
            });
        }, 0);
    }, [loading, creditCards]);

    const fetchCreditCards = async () => {
        try {
            setLoading(true);
            const data = await getAllCreditCard();
            const sortedData = data.sort(
                (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
            );
            setCreditCards(sortedData);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openModal = (card) => {
        setSelectedCard(card);
        setStatus(card.status || "Pending");
        setScreenshot(null);
        setCsId(card.csId || "");
        new window.bootstrap.Modal(document.getElementById('creditcard-modal')).show();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedCard) {
            alert("No credit card selected.");
            return;
        }

        const formData = new FormData();
        formData.append("csId", csId);
        formData.append("status", status);
        if (screenshot) {
            formData.append("screenshot", screenshot);
        }

        try {
            await updateCreditCardStatus(selectedCard.id, formData);
            // alert("Status updated successfully!");

            fetchCreditCards(); // Refresh data

            // Close modal and clear form
            const modalElement = document.getElementById('creditcard-modal');
            const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
            modalInstance?.hide();
            setSelectedCard(null);
            setStatus("Pending");
            setScreenshot(null);
            setCsId("");
        } catch (error) {
            console.error("Error updating status:", error);
            alert("Failed to update status.");
        }
    };

    const STATUS_MAP = {
        0: "Pending",
        1: "Approved",
        2: "Rejected",
        3: "VKYC Pending",
        4: "VKYC Done",
        5: "Biomatric Pending",
        6: "Biomatric Done"
    };


    return (
        <>

            <Table />

            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">All Credit Cards Data</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">All Credit Cards Data</h4>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="tab-content">
                                                <div className="tab-pane show active" id="fixed-columns-preview">

                                                    <div className="table-responsive">
                                                        <table ref={tableRef} id="fixed-columns-datatable" className="table table-striped table-bordered table-hover nowrap row-border order-column w-100">
                                                            <thead>
                                                                <tr>
                                                                    <th>Date</th>
                                                                    <th>Created By</th>
                                                                    <th>Date</th>
                                                                    <th>First name</th>
                                                                    <th>Last name</th>
                                                                    <th>Mobile</th>
                                                                    <th>Email</th>
                                                                    <th>Pan Card No.</th>
                                                                    <th>Pincode</th>
                                                                    <th>Bank Name</th>
                                                                    <th>CS Id</th>
                                                                    <th>Status</th>
                                                                    {/* <th>Final Status</th> */}
                                                                    <th>Remarks</th>
                                                                    <th>Status ScreenShot</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {creditCards.length > 0 ? (
                                                                    creditCards.map((card) => (
                                                                        <tr key={card.id}>
                                                                            <td>{new Intl.DateTimeFormat('en-GB', {
                                                                                day: '2-digit',
                                                                                month: '2-digit',
                                                                                year: 'numeric',
                                                                            }).format(new Date(card.createdDate))}</td>
                                                                            <td>
                                                                                {card.user.name}{' '} <br/>
                                                                                <a href={`tel:${card.user.mobile}`}>
                                                                                    {card.user.mobile}
                                                                                </a>
                                                                            </td>
                                                                            <td>{card.customer.firstName}</td>
                                                                            <td>{card.customer.lastName}</td>
                                                                            <td>{card.customer.mobile}</td>
                                                                            <td>{card.customer.email}</td>
                                                                            <td>{card.customer.panCardNo}</td>
                                                                            <td>{card.customer.pincode}</td>
                                                                            <td>{card.creditCard.banknamecreditcard}</td>
                                                                            <td>{card.csId}</td>
                                                                            <td>{STATUS_MAP[card.status] ?? card.status}</td>
                                                                            {/* <td>{card.finalStatus}</td> */}
                                                                            <td>{card.remarks}</td>
                                                                            {/* <td>{card.status}</td> */}
                                                                            <td>
                                                                                {card.screenShot && (
                                                                                    <img
                                                                                        src={`https://api.mysfs24.com/${card.screenShot?.replace('../', '')}`}
                                                                                        alt="Credit Card Status"
                                                                                        height="100"
                                                                                    />
                                                                                )}
                                                                            </td>
                                                                            <td className="table-action">
                                                                                <i
                                                                                    className="mdi mdi-pencil action-icon"
                                                                                    onClick={() => openModal(card)}

                                                                                ></i>
                                                                            </td>

                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="8" className="text-center">No Data Found</td>
                                                                    </tr>
                                                                )}


                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div> {/* end preview*/}
                                            </div> {/* end tab-content*/}
                                        </div> {/* end card body*/}
                                    </div> {/* end card */}
                                </div>{/* end col*/}
                            </div> {/* end row*/}
                            {/* Modal */}
                            <div id="creditcard-modal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-body">
                                            <div className="text-center mt-2 mb-4">
                                                {selectedCard && (
                                                    <>
                                                        <img src={selectedCard.imagecreditcard} alt="" height={50} />
                                                        <h5 className="mt-2">{selectedCard.creditCard.banknamecreditcard.toUpperCase()}</h5>
                                                    </>
                                                )}
                                            </div>
                                            <form onSubmit={handleSubmit}>
                                                {/* CS Id Field */}
                                                <div className="mb-3">
                                                    <label className="form-label">CS Id</label>
                                                    <input className="form-control" type="text" value={csId} onChange={(e) => setCsId(e.target.value)} />
                                                </div>
                                                {/* Status Dropdown */}
                                                <div className="mb-3">
                                                    <label className="form-label">Status</label>
                                                    <select className="form-control" value={status} onChange={(e) => setStatus(e.target.value)}>
                                                        <option value="Pending">Pending</option>
                                                        <option value="Approved">Approved</option>
                                                        <option value="Rejected">Rejected</option>
                                                        <option value="VKYCPending">VKYC Pending</option>
                                                        <option value="VKYCDone">VKYC Done</option>
                                                        <option value="BiomatricPending">Biomatric Pending</option>
                                                        <option value="BiomatricDone">Biomatric Done</option>
                                                    </select>
                                                </div>
                                                {/* Screenshot Upload */}
                                                <div className="mb-3">
                                                    <label className="form-label">Screenshot</label>
                                                    <input className="form-control" type="file" onChange={(e) => setScreenshot(e.target.files[0])} />
                                                </div>
                                                <div className="d-grid">
                                                    <button type="submit" className="btn btn-primary">Submit</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Outlet />

        </>
    )
}

export default AllCreditCardDataAdmin